// src/Home.js

import React,{ useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../Header';
import Footer from '../Footer';
import { useNavigate } from 'react-router-dom';

import './styles.css';
function MeusPedidos() {
  
  const title = "Meus Pedidos";
  const footerText = "© 2025 All rights reserved.";
  
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); // Para redirecionar
  function formatarDataHumanizada(dataString) {
    const data = new Date(dataString);

    return new Intl.DateTimeFormat("pt-BR", {
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    }).format(data);
  }
  function moeda(valor){
    return new Intl.NumberFormat('pt-BR', { 
      minimumFractionDigits: 2, 
      maximumFractionDigits: 2 
    }).format(valor)
  }
  function situacao(situacao){
    if(situacao===0){
      return "Cancelado";
    }
    if(situacao===1){
      return "Processando pagamento";
    }
    if(situacao===2){
      return "Pagamento confirmado";
    }
    if(situacao===3){
      return "Enviado";
    }
    
    if(situacao===4){
      return "Concluído";
    }
    return "entre em contato com o suporte"
  }
  useEffect(() => {
    // Fazendo a chamada para a API
    var tokenUsuario = localStorage.getItem("token");

    if(tokenUsuario){
      fetch('https://api.streetfightermotoparts.com.br/api/compras', {
        method: 'GET', // O método pode ser 'GET' ou outro conforme sua API
        headers: {
          'Content-Type': 'application/json', // Tipo de conteúdo da requisição
          'Authorization': `Bearer ${tokenUsuario}` // Adiciona o token Bearer
        }
      })
      .then(response => response.json()) // Converte a resposta para JSON
      .then(data => {
        setData(data);

        /*if(data.message){
          window.abrirLogin(true);

        }
        else{
          //navigate("/finalizarCompra");
        }*/
        setLoading(false); // Atualiza o estado para indicar que o carregamento terminou
      })
      .catch(error => {
        setLoading(false); // Atualiza o estado para indicar que o carregamento terminou
        console.error('Erro ao buscar dados:', error);
      });
      
    }
    else{
      
      navigate("/");
    }
  }, [navigate]); // Incluindo 'id' e 'navigate' no array de dependências
  if (loading) {
    return <div>Carregando...</div>;
  }
  return (
    <div>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content="Welcome to the Home Page of our application." />
      </Helmet>
      <Header title={title} />
      <main>
        {/*<img width="100%" src="https://images.aemelectronics.com/aem_heroslider_digitaldash.jpg" alt="imagem 1"></img>
        <h2>Bem-vindo a página de sensores!</h2>*/}
        <h2>{title}</h2>
        {data.length===0?(<div>Nenhum pedido encontrado.</div>):(<div></div>)}
        <ul className='compras'>
          {data.map((compra) => (
            <li  key={compra.idVenda} className='listaCompra'>
              <div className='dataCompra'><span title={compra.enderecoRua + ", "+compra.enderecoNumero+ ", "+compra.enderecoBairro+ ", "+compra.enderecoCidade+ ", "+compra.enderecoEstado}>#{compra.idVenda}</span> <span>{formatarDataHumanizada(compra.dataVenda)}</span></div>
              
              {compra.produtos_venda.map((produtoVenda) => (
                <div key={"pv"+produtoVenda.idProdutosVenda} className='produtoDaVenda'>
                  <div>
                    <img className="imagemCompraProduto" src={produtoVenda.produto.fotoCapa} alt={"Imagem do "+produtoVenda.produto.nome}/>

                  </div>
                  <div>
                    <h2>
                      {produtoVenda.produto.nome}
                    </h2>
                    {produtoVenda.observacaoProduto}

                  </div>
                </div>
              ))}
              <div className='valorCompra'>
                
                <span>
                    Situação: {situacao(compra.statusVenda)}
                </span>
                <span>
                    Total: R$ {compra.observacaoPagamento==="Pix"? (<span>{moeda(compra.valorDesconto)}</span>):(<span>{moeda(compra.valor)} (PIX)</span>)}
                </span>
              </div>
            </li>
          ))}
        </ul>
      </main>
      <Footer footerText={footerText} />
    </div>
  );
}

export default MeusPedidos;
